import React from 'react';

const NearMe = ({
  color = 'var(--color-primary)',
  width = 16,
  height = 22,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 22"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeWidth="1.4"
      transform="translate(1 1)"
    >
      <path d="M6.313 19c4.857-5.423 7.285-9.423 7.285-12 0-3.866-3.044-7-6.799-7C3.044 0 0 3.134 0 7c0 2.577 2.104 6.577 6.313 12z" />
      <ellipse cx="6.799" cy="7" rx="2.914" ry="3" />
    </g>
  </svg>
);

export default NearMe;
